import React from "react";
import { connect } from "react-redux";
import moment from "moment";

const getKindName = (kind) => {
  switch (kind) {
    case "daily_summary":
      return "Rozliczenie dzienne";
    case "payout":
      return "Wypłata monet";
  }
};

const TransactionsTable = ({ data, handleMarkRow }) => {
  return (
    <div className="dashboard">
      <div className="dashboard__modal-table m-t-0">
        <table>
          <tr className="sub-head">
            <th>Data</th>
            <th style={{ padding: 5 }}>Ilość zdobytych monet</th>
            <th style={{ padding: 5 }}>Saldo po</th>
            <th style={{ padding: 5 }}>Opis</th>
            <th style={{ padding: 5 }}>Typ</th>
          </tr>
          {data.map(
            ({ id, kind, amount, balance_after, description, reported_at }) => (
              <tr className="table-row" key={id}>
                <td style={{ textAlign: "center" }}>
                  <strong>
                    {reported_at
                      ? moment(reported_at).format("DD-MM-YYYY")
                      : "-"}
                  </strong>
                </td>
                <td
                  style={{
                    padding: 5,
                  }}
                >
                  {kind === "daily_summary" ? (
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        handleMarkRow(reported_at);
                      }}
                    >
                      <strong
                        className={
                          amount > 0
                            ? "text-underline text-pointer text-success"
                            : amount < 0
                            ? "text-underline text-pointer text-danger"
                            : "text-underline text-pointer"
                        }
                      >
                        {amount > 0 ? "+" : ""}
                        {parseFloat(amount).toFixed(2)}
                      </strong>
                    </a>
                  ) : (
                    <strong
                      className={
                        amount > 0
                          ? "text-success"
                          : amount < 0
                          ? "text-danger"
                          : ""
                      }
                    >
                      {amount > 0 ? "+" : ""}
                      {parseFloat(amount).toFixed(2)}
                    </strong>
                  )}
                </td>
                <td
                  style={{
                    padding: 5,
                  }}
                >
                  <strong
                    className={
                      kind === "daily_summary"
                        ? balance_after > 0
                          ? "text-success"
                          : balance_after < 0
                          ? "text-danger"
                          : ""
                        : ""
                    }
                  >
                    {parseFloat(balance_after).toFixed(2)}
                  </strong>
                </td>
                <td
                  style={{
                    padding: 5,
                  }}
                >
                  {description?.length > 0 ? (
                    description.split("\n").map((item, index) => (
                      <p key={index}>
                        <strong>{item}</strong>
                      </p>
                    ))
                  ) : (
                    <strong>{description || "-"}</strong>
                  )}
                </td>
                <td>
                  <strong>{getKindName(kind)}</strong>
                </td>
              </tr>
            )
          )}
        </table>
      </div>
    </div>
  );
};

export default connect(
  ({
    packer_dashboard: {
      data: { tradecoin_transactions: data },
    },
  }) => ({
    data,
  })
)(TransactionsTable);
